import { useQuery } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { Revenue } from '@/types'

type ReadCompanyRevenueParams = {
  company_key: string
  year?: number
}

export async function readCompanyRevenue({
  company_key,
  ...params
}: ReadCompanyRevenueParams) {
  const response = await httpClient('accounting-dealer').get<Revenue[]>(
    `/v3/company/${company_key}/revenue`,
    { params },
  )

  return response.data
}

export function useReadCompanyRevenue({
  company_key,
  year,
}: ReadCompanyRevenueParams) {
  return useQuery({
    queryKey: ['company-revenue', company_key, year],
    queryFn: () => readCompanyRevenue({ company_key, year }),
  })
}
